import { queue_group_mapping } from "../constants/ccpAttributeSchema";

function validatePhoneNumber(input_str) {
  var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

  return re.test(input_str);
}

const phoneFormat = (input) => {
  if (validatePhoneNumber(input) && input.indexOf('+1') < 0) {
    return `+1${input}`;
  } else {
    return input;
  }
}
export const getContactDetails = (contact) => {
  console.log("getContactDetails", contact.getQueue())
  const contactInfo = {
    contactId: contact.getContactId(),
    originalContactId: contact.getOriginalContactId() == null ? contact.getContactId() : contact.getOriginalContactId(),
    dialedNumber: 'NA',
    type: contact.getType(),
    contact: contact
  };

  contactInfo.groupCopy = `${contactInfo.contactId}`;
  const attributes = contact.getAttributes();
  if (attributes && attributes.queueName) {
    contactInfo.queueName = attributes.queueName.value;
    contactInfo.groupCopy = `${contactInfo.groupCopy}|${contactInfo.queueName}`;
  }

  const queue = contact.getQueue();
  if (queue) {
    contactInfo.queue = queue.name;
    // contactInfo.groupCopy = `${contactInfo.groupCopy}|${contactInfo.queue}`;
  }

  if (contact.getType() === window.connect.ContactType.VOICE) {
    const activeEndpoint = contact.getActiveInitialConnection()
      && contact.getActiveInitialConnection().getEndpoint();

    if (activeEndpoint) {
      contactInfo.phone = activeEndpoint.phoneNumber;
      contactInfo.groupCopy = `${contactInfo.groupCopy}|${contactInfo.phone}`;
    }
  }

  if (contact.getType() === window.connect.ContactType.CHAT) {
    if (attributes && attributes.phoneNumber) {
      contactInfo.phone = attributes.phoneNumber.value;
      contactInfo.groupCopy = `${contactInfo.groupCopy}|${contactInfo.phone}`;
    }
  }

  if (attributes && attributes.dialedNumber) {
    contactInfo.dialedNumber = attributes.dialedNumber.value;
    contactInfo.groupCopy = `${contactInfo.groupCopy}|${contactInfo.dialedNumber}`;
  }

  // For Chat derive attributes
  if (contact.getType() === window.connect.ContactType.CHAT) {
    if (attributes && attributes.email) {
      contactInfo.custEmail = attributes.email.value;
    }
    contactInfo.groupCopy = `${contactInfo.groupCopy}|${contactInfo.dialedNumber}`;
  }

  if (attributes && attributes.fName) {
    contactInfo.fName = attributes.fName.value;
  }

  return contactInfo;
};

export const getContactAttributes = (contact) => {
  console.log("getContactAttributes : ", contact.getQueue().name)
  const attributes = contact.getAttributes();
  if (!attributes) {
    return [];
  }

  // debugger;
  let queue = contact.getQueue().name;
  let foundQueueGrp = null;
  Object.keys(queue_group_mapping).forEach((value) => {
    const values = queue_group_mapping[value];
    if (Array.isArray(values)) {
      for (let data of values) {
        if (queue === data) {
          foundQueueGrp = value;
          break;
        } else {
          console.log("No Group Found");
        }
      }
    }

    if (typeof values === 'object' && !Array.isArray(values)) {
      if(queue.startsWith(values.value.ST) && !queue.endsWith(values.value.NOTEN)) {
        foundQueueGrp = value;
        return;
      }
    }
    
  });

  // debugger;
  if (foundQueueGrp) {
    return Object.values(attributes)
  }

  const filteredAttributes = Object.values(attributes)
    .filter((e) => {

      if (
        e.name.includes('ivrOriginName')
        || e.name.includes('IaName')
        || e.name.includes('callReason')
        || e.name.includes('transfercallReason')
        || e.name.includes('dialedNumber')
        || e.name.includes('forecastCode')
        || e.name.includes('agentMessage')
        || e.name.includes('IVRUtterance')
        || e.name.includes('chatReason')
      ) { return true; }
      return false;
    });
  return Object.values(filteredAttributes); // returns [{ name: "", value: "" }, ... ]
};
